export const getTermsAndConditionsTypes = () => ({
  NONE: 1,
  STANDARD: 2,
  UPLOAD: 3
})
